import { staticUrl } from "../../config";

const Logo = ({ size }) => {
  let sizeClass = "h-8 w-auto";

  switch (size) {
    case "extra-large":
      sizeClass = "h-12 w-auto";
      break;
    case "large":
      sizeClass = "h-10 w-auto";
      break;
    case "medium":
    case "tablet":
      sizeClass = "h-6 w-auto";
      break;
    case "small":
      sizeClass = "h-4 w-auto";
      break;
  }

  return (
    <img
      id="logo"
      src={`${staticUrl}/img/logo-1.svg`}
      alt="Kingsley Bate Logo"
      className={sizeClass}
      width="396px"
      height="32px"
    />
  );
};

export { Logo };
